module.exports = __webpack_public_path__ + "static/img/14.7b101c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/14.png
// module id = RTaV
// module chunks = 0